import React from 'react'
import { FormattedMessage } from 'react-intl'
import { isMobile, isTablet } from 'react-device-detect'
import _ from 'lodash'
import PropTypes from 'prop-types'

import { Col, Row } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'

import {
  InterTitle,
  StyledGroup,
  InputWrapper,
  StyledRadioButtonMobile,
  StyledCol,
  StyledMessage,
  SVGWrapper,
  StyledRadioButton
} from '../../styled'

const TYRE_WEAR = {
  NEW: 0,
  MEDIUM: 50,
  BAD: 100
}

export const TYRE_SIDE = {
  FRONT: 'front',
  BACK: 'back'
}

const FormItem = ({ vehicle, side, second, onChange }) => {
  const handleChange = e => {
    const { value } = e.target

    const extendedVehicle = {
      ...vehicle,
      [second
        ? `secondTiresState${_.upperFirst(side)}`
        : `tiresState${_.upperFirst(side)}`]: Number(value)
    }

    onChange(extendedVehicle)
  }

  return (
    <>
      <InterTitle>
        <FormattedMessage id={`tradeIn-state-tires-${side === TYRE_SIDE.FRONT ? 1 : 2}`} />
      </InterTitle>

      <StyledGroup
        buttonStyle="solid"
        value={
          vehicle[
            second ? `secondTiresState${_.upperFirst(side)}` : `tiresState${_.upperFirst(side)}`
          ]
        }
        onChange={handleChange}
      >
        <InputWrapper type="flex">
          {Object.values(TYRE_WEAR).map((tyreWear, index) => (
            <Col span={isMobile && !isTablet ? 8 : 6} key={index}>
              {isMobile ? (
                <>
                  <StyledRadioButtonMobile value={tyreWear}>
                    <StyledCol span={24}>
                      <SVG svg={svg[`tires_status_${index + 1}`]} />
                    </StyledCol>
                    <StyledMessage>
                      <FormattedMessage id={`tradeIn-state-view-tires-state-${index + 1}`} />
                    </StyledMessage>
                  </StyledRadioButtonMobile>
                </>
              ) : (
                <>
                  <Row type="flex" justify="center">
                    <StyledCol span={12}>
                      <SVGWrapper>
                        <SVG svg={svg[`tires_status_${index + 1}`]} />
                      </SVGWrapper>
                    </StyledCol>
                  </Row>
                  <Row type="flex" justify="center">
                    <StyledCol span={24}>
                      <StyledRadioButton value={tyreWear}>
                        <FormattedMessage id={`tradeIn-state-view-tires-state-${index + 1}`} />
                      </StyledRadioButton>
                    </StyledCol>
                  </Row>
                </>
              )}
            </Col>
          ))}
        </InputWrapper>
      </StyledGroup>
    </>
  )
}

FormItem.defaultProps = {
  second: false
}

FormItem.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  side: PropTypes.oneOf([TYRE_SIDE.BACK, TYRE_SIDE.FRONT]).isRequired,
  second: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

export default { FormItem, TYRE_SIDE }
